/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstanceBulkLostRequest
 */
export interface InstanceBulkLostRequest {
    /**
     * 
     */
    lead_ids: Array<string>;
    /**
     * 
     */
    date_lost: string;
    /**
     * 
     */
    reason: string;
    /**
     * 
     */
    comment?: string;
}

/**
 * Check if a given object implements the InstanceBulkLostRequest interface.
 */
export function instanceOfInstanceBulkLostRequest(value: object): value is InstanceBulkLostRequest {
    if (!('lead_ids' in value) || value['lead_ids'] === undefined) return false;
    if (!('date_lost' in value) || value['date_lost'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function InstanceBulkLostRequestFromJSON(json: any): InstanceBulkLostRequest {
    return InstanceBulkLostRequestFromJSONTyped(json, false);
}

export function InstanceBulkLostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkLostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
        'date_lost': json['date_lost'],
        'reason': json['reason'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function InstanceBulkLostRequestToJSON(json: any): InstanceBulkLostRequest {
    return InstanceBulkLostRequestToJSONTyped(json, false);
}

export function InstanceBulkLostRequestToJSONTyped(value?: InstanceBulkLostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_ids': value['lead_ids'],
        'date_lost': value['date_lost'],
        'reason': value['reason'],
        'comment': value['comment'],
    };
}

